export interface ISakskategoriSimple {
    id: number;
    type: string;
}

export class SakskategoriSimple implements ISakskategoriSimple {
    public id: ISakskategoriSimple['id'];
    public type: ISakskategoriSimple['type'];

    constructor(obj: ISakskategoriSimple) {
        this.id = obj.id;
        this.type = obj.type;
    }
}
